export default __webpack_public_path__ + "static/media/study.69cf4f28.png";